<template>
  <div class="descriptionOfPack">
    <div class="reportBasic-subTitle">
      {{ $tc('lang.FabricReport.PACKING_INFORMATION') }}
    </div>
    <div class="desOfGoods-con">
      <span>{{ $tc('lang.FabricReport.Confirmed_packing_information') }}</span>
      <a-radio-group name="radioGroup" v-model="freportPackinginformation">
        <a-radio value="1">{{ $tc('lang.FabricReport.yes') }}</a-radio>
        <a-radio value="2">{{ $tc('lang.FabricReport.no') }}</a-radio>
      </a-radio-group>
      <!-- <div class="button-group">
        <a-button
          type="primary"
          size="small"
          :loading="confirmLoading"
          @click="handleSubmit"
          >保存</a-button
        >
      </div> -->
    </div>
    <div class="desOfGoods-con">
      <span>{{ $tc('lang.FabricReport.Roll_Packed_Details') }}</span>
      <div class="img">
        <show-img
          :data="descriptionOfPack.fmediaRollpackeddetails"
          :otherData="{
            mediaName: '单卷面料封装方式',
            mediaType: 3,
            personId: '',
            orderId: '',
            reportId: '',
            mediaDesc: 'fmediaRollpackeddetails',
          }"
          :id="id"
        ></show-img>
      </div>
      <!-- <div class="button-group">
        <a-button
          type="primary"
          size="small"
          @click="
            saveImg(
              descriptionOfPack.fmediaRollpackeddetails,
              'fmediaRollpackeddetails',
            )
          "
          >保存</a-button
        >
      </div> -->
    </div>
    <div class="desOfGoods-con">
      <span>{{ $tc('lang.FabricReport.Shipping_Mark_Lable') }}</span>
      <div class="img">
        <show-img
          :data="descriptionOfPack.fmediaShippingmark"
          :otherData="{
            mediaName: '唛头及产品标签',
            mediaType: 3,
            personId: '',
            orderId: '',
            reportId: '',
            mediaDesc: 'fmediaShippingmark',
          }"
          :id="id"
        ></show-img>
      </div>
      <!-- <div class="button-group">
        <a-button
          type="primary"
          size="small"
          @click="
            saveImg(descriptionOfPack.fmediaShippingmark, 'fmediaShippingmark')
          "
          >保存</a-button
        >
      </div> -->
    </div>
    <div class="desOfGoods-con">
      <span>{{ $tc('lang.FabricReport.Inner_Packing_Details') }}</span>
      <div class="img">
        <show-img
          :data="descriptionOfPack.fmediaInnerpackingdetails"
          :otherData="{
            mediaName: '开包装产品展示',
            mediaType: 3,
            personId: '',
            orderId: '',
            reportId: '',
            mediaDesc: 'fmediaInnerpackingdetails',
          }"
          :id="id"
        ></show-img>
      </div>
      <!-- <div class="button-group">
        <a-button
          type="primary"
          size="small"
          @click="
            saveImg(
              descriptionOfPack.fmediaInnerpackingdetails,
              'fmediaInnerpackingdetails',
            )
          "
          >保存</a-button
        >
      </div> -->
    </div>
    <div class="desOfGoods-con">
      <span>{{ $tc('lang.FabricReport.Collateral_Others') }}</span>
      <div class="img">
        <show-img
          :data="descriptionOfPack.fmediaCollateral"
          :otherData="{
            mediaName: '辅料/产品细节展示',
            mediaType: 3,
            personId: '',
            orderId: '',
            reportId: '',
            mediaDesc: 'fmediaCollateral',
          }"
          :id="id"
        ></show-img>
      </div>
      <!-- <div class="button-group">
        <a-button
          type="primary"
          size="small"
          @click="
            saveImg(descriptionOfPack.fmediaCollateral, 'fmediaCollateral')
          "
          >保存</a-button
        >
      </div> -->
    </div>
  </div>
</template>
<script>
import showImg from './showImg';
export default {
  data() {
    return {
      freportPackinginformation:
        this.$store.state.report.fabricDetails.freportPackinginformation + '',
      confirmLoading: false,
      id: this.$route.query.id,
    };
  },
  created() {
    console.log(this.freportPackinginformation, 111);
  },
  components: {
    showImg,
  },
  computed: {
    fabricDetails: {
      get() {
        return this.$store.state.report.fabricDetails;
      },
      set(val) {
        this.$store.commit('report/save', { fabricDetails: val });
      },
    },
    descriptionOfPack: {
      get() {
        return JSON.parse(
          JSON.stringify(
            this.$store.state.report.fabricImgList.descriptionOfPack,
          ),
        );
      },
    },
  },
  methods: {
    getDetail() {
      this.$http
        .post('/hzwmj/workorder-fabricreport/getFabricInfo', {
          id: this.id,
        })
        .then(data => {
          if (data) {
            this.fabricDetails = data.data;
          } else {
            this.fabricDetails = {};
          }
        })
        .catch(() => {
          this.fabricDetails = {};
        });
    },
    handleSubmit() {
      this.confirmLoading = true;
      this.$http
        .post('/hzwmj/workorder-fabricreport/saveOrUpdateLoadigreport', {
          freportId: this.fabricDetails.freportId,
          freportPackinginformation: this.freportPackinginformation,
          modelType: '3',
        })
        .then(data => {
          if (data) {
            this.$message.success('保存成功');
            this.confirmLoading = false;
            this.getDetail();
            // this.details = data;
          } else {
            this.$message.error('保存失败');
            this.confirmLoading = false;
          }
        })
        .catch(() => {
          this.$message.error('保存失败');
          this.confirmLoading = false;
        });
    },
    // saveImg(data, type) {
    saveImg() {
      let fileList = [];
      let fileList1 = [];
      let fileList2 = [];
      let fileList3 = [];
      this.descriptionOfPack.fmediaRollpackeddetails.forEach(item => {
        fileList.push(item.id);
      });
      this.descriptionOfPack.fmediaShippingmark.forEach(item => {
        fileList1.push(item.id);
      });
      this.descriptionOfPack.fmediaInnerpackingdetails.forEach(item => {
        fileList2.push(item.id);
      });
      this.descriptionOfPack.fmediaCollateral.forEach(item => {
        fileList3.push(item.id);
      });
      let postData = {
        ireportId: this.fabricDetails.freportId,
        imediaName: '包装情况',
        imediaSaveType: '1',
        modelType: '3',
        fmediaRollpackeddetails: fileList.join(','),
        fmediaShippingmark: fileList1.join(','),
        fmediaInnerpackingdetails: fileList2.join(','),
        fmediaCollateral: fileList3.join(','),
      };
      // postData[type] = fileList.join(',');
      this.$http
        .post('/hzwmj/fabric-media/saveOrUpdateFabricMedia', postData)
        .then(data => {
          if (data) {
            // this.visible = false;
            this.$message.success('保存成功');
            this.$store.dispatch(
              'report/getfabricImg',
              this.fabricDetails.freportId,
            );
          } else {
            this.$message.error('保存失败');
          }
        })
        .catch(() => {
          this.$message.error('保存失败');
        });
    },
  },
};
</script>
<style lang="less">
.descriptionOfPack {
  .desOfGoods-con {
    display: flex;
    margin-top: 30px;
    .button-group {
      width: 130px;
      flex-shrink: 0;
    }
    .img {
      flex-grow: 1;
    }
    > span {
      display: inline-block;
      width: 100px;
      flex-shrink: 0;
      padding-left: 20px;
      // text-align: center;
    }
    // img {
    //   width: 20%;
    //   height: 150px;
    //   margin: 0 20px 20px;
    // }
  }
  .desOfGoods-table {
    display: flex;
    .desOfGoods-table1 {
      flex-grow: 1;
      margin-left: 20px;
      .ant-table-footer {
        padding: 0;
        .footer1 {
          border-right: 1px solid #e8e8e8;
          width: 30%;
        }
        p {
          display: inline-block;
          padding: 0 16px;
          margin-bottom: 0;
          line-height: 52px;
        }
      }
    }
    .button-group {
      width: 130px;
      flex-shrink: 0;
    }
  }
}
</style>
